export default __webpack_public_path__ + "static/home2-63f71b9bf4c4390a4ca9a45703396fb2.jpg";